import React, { ReactNode } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import classnames from 'classnames'
import Button from 'components/Base/Button'
import Seo from 'components/seo'
import Tab from 'components/ManageUnit/Tab'
import EntertainmentBanner from 'components/Entertainment/EntertainmentBanner'
import CourseCard from 'components/ManageUnit/CourseCard'
import SectionSubstance, { SectionSubstanceBody } from 'components/SectionSubstance'
import ScanCodeConsultButton from 'components/ScanCodeConsultButton'
import Panorama from 'components/Panorama'
import ProductCard from 'components/ProductCard'
import PartnerCard from 'components/PartnerCard'
import CardList from 'components/ManageUnit/CardList'
import CargoCard from 'components/CargoCard'
import ArticleFooter from 'components/ArticleFooter'
import Layout from 'layouts/zh'
import { Languages } from 'i18n/config'
import * as styles from './index.module.less'
import Target from 'src/pages/target_disassembly/target/index.zh'

const Webhot: React.FC = (props) => {
  const { webhotYaml } = useStaticQuery(graphql`
    query {
      webhotYaml {
        title
        description
        keywords
        software_title
        software_titleMb
        saTitle
        software_sectionCardList {
          desc
          title
          cover
        }
        software_buttonText
        software_qrcode
        panorama_title
        panorama_titleMb
        panorama_desc
        panorama_btnText
        panorama_btnCode
        panorama_imgUrl
        partner_desc
        partner_title
        partner_titleMb
        partner_imgBottomText
        partner_banner
        partner_bannerMb
        partner_dataList {
          imgUrl
        }
        partner_buttonText
        partner_qrcode
        cargo_title
        cargo_titleMb
        cargo_dataList {
          btnHref
          btnText
          dataMsg
          dataTitle
          imgUrl
          imgUrlMb
        }
        product_title
        product_titleMb
        product_dataList {
          btnHref
          btnText
          dataDsc
          dataMsg
          dataTitle
          imgUrl
          imgUrlMb
        }
        digitization_btnHref
        digitization_btnText
        digitization_desc
        digitization_orderHref
        digitization_orderText
        digitization_title
        banner_title
        banner_Desc
        banner_buttonHref
        banner_buttonText
        banner_qrcodeButtonText
        banner_sectionTwoDesc
        banner_sectionTwoTitle
        banner_sectionTwoTitleMb
        banner_icon
        banner_icon_mb
        banner_dataSource {
          buttonHref
          buttonText
          dataTitle
          descList
          qrcodeUrl
        }
        banner_list {
          isActive
          name
          url
        }
        tools_buttonLink
        tools_buttonText
        tools_thumb
        tools_descList {
          label
          list
          value
        }
        tools_title
      }
    }
  `)

  return (
    <Layout {...props}>
      <WebhotState webhotYaml={webhotYaml} />
    </Layout>
  )
}

interface WebhotStateProps {
  demoUrl?: string
  paradeUrl?: string
  lang?: Languages
  webhotYaml: any
  slotPartnerSection?: ReactNode
  slotPanoramaSection?: ReactNode
  className?: string
}
export const WebhotState: React.FC<WebhotStateProps> = ({
  webhotYaml,
  slotPartnerSection,
  slotPanoramaSection,
  className,
}) => {
  return (
    <>
      <Seo
        title={webhotYaml?.title}
        description={webhotYaml?.description}
        keywords={webhotYaml?.keywords}
        saTitle={webhotYaml?.saTitle}
      />
      <main className={classnames(styles.Webhot, className)}>
        <EntertainmentBanner
          iconClassName="bannerIcon"
          bannerDescClassName="banner-desc"
          bannerClassName="webhot-banner"
          bannerTitleClassName="banner-title"
          sectionTwoWrapClassName="webhot-sectionTow"
          bannerCenter
          bannerTitle={webhotYaml?.banner_title}
          bannerDesc={webhotYaml?.banner_Desc}
          bannerIcon={webhotYaml?.banner_icon}
          bannerIconMB={webhotYaml?.banner_icon_mb}
          sectionTwoTitle={webhotYaml?.banner_sectionTwoTitle}
          sectionTwoDesc={webhotYaml?.banner_sectionTwoDesc}
          sectionTwoTitleMB={webhotYaml?.banner_sectionTwoTitleMb}
          dataSource={webhotYaml?.banner_dataSource?.map((item) => ({ ...item, imgUrl: item?.qrcodeUrl }))}
          slotBannerButton={
            <Button
              className="mt-[30px]"
              btnType="white"
              shape="circle"
              target="_blank"
              href={webhotYaml?.banner_buttonHref}
            >
              {webhotYaml?.banner_buttonText}
            </Button>
          }
          slotSectionTwoMobileButton={
            <Button className="banner-btn" btnType="primary" shape="circle" href={webhotYaml?.banner_buttonHref}>
              {webhotYaml?.banner_qrcodeButtonText}
            </Button>
          }
          slotTab={
            <Tab
              className="pt-[20px] webhot-tab"
              textColor="text-[#6B82E4]"
              bgColor="bg-[#6B82E4]"
              shadow="shadow-[0_10px_30px_0_rgba(107,125,228,0.3)]"
              list={webhotYaml?.banner_list}
            />
          }
        />
        <SectionSubstance
          titleTextAlignMb="left"
          title={webhotYaml?.software_title}
          titleMb={webhotYaml?.software_titleMb}
          className="toolsSoftware"
        >
          <SectionSubstanceBody>
            <CardList
              isHeight={false}
              titleColor="#1F2D3D"
              coverWidth={180}
              coverHeight={180}
              autoplay
              yGap={40}
              xGap={32}
              mYGap={20}
              mXGap={0}
              datas={webhotYaml?.software_sectionCardList}
            />
            <div className="webhot-btn">
              <ScanCodeConsultButton
                buttonText={webhotYaml?.software_buttonText}
                shape="circle"
                qrcode={webhotYaml?.software_qrcode}
              />
            </div>
          </SectionSubstanceBody>
        </SectionSubstance>
        {webhotYaml?.tools_title && (
          <SectionSubstance className="toolsProduction">
            <CourseCard
              className="toolsContainer"
              title={webhotYaml?.tools_title}
              thumb={webhotYaml?.tools_thumb}
              buttonText={webhotYaml?.tools_buttonText}
              buttonHref={webhotYaml?.tools_buttonLink}
              descList={webhotYaml?.tools_descList}
            />
          </SectionSubstance>
        )}
        {slotPanoramaSection ? (
          slotPanoramaSection
        ) : (
          <SectionSubstance
            titleTextAlignMb="left"
            className="panorama"
            titleMb={webhotYaml?.panorama_titleMb}
            title={webhotYaml?.panorama_title}
            descText={webhotYaml?.panorama_desc}
          >
            <Panorama
              className="panorama-container"
              btnText={webhotYaml?.panorama_btnText}
              btnCode={webhotYaml?.panorama_btnCode}
              imgUrl={webhotYaml?.panorama_imgUrl}
              btnTextTwo={webhotYaml?.panorama_btnText_two}
              btnTextTwoUrl={webhotYaml?.panorama_btnText_two_url}
            />
            {/* 背景图 */}
            <div className="panorama-bgc">
              <img
                className="panorama-bgc-pc"
                src={require('assets/images/solution/webhot/webhot-panorama-bgc.png').default}
              />
              <img
                className="panorama-bgc-mb"
                src={require('assets/images/solution/webhot/webhot-panorama-bgc-mb.png').default}
              />
            </div>
          </SectionSubstance>
        )}
        {slotPartnerSection ? (
          slotPartnerSection
        ) : (
          <SectionSubstance
            titleTextAlignMb="left"
            className="webhot-partner"
            title={webhotYaml?.partner_title}
            titleMb={webhotYaml?.partner_titleMb}
            descText={webhotYaml?.partner_desc}
          >
            <PartnerCard className="lg:pt-[40px] pt-[2rem]" dataSource={webhotYaml?.partner_dataList} />
            <div className="partner-btn">
              <ScanCodeConsultButton
                imgBottomText={webhotYaml?.partner_imgBottomText}
                buttonText={webhotYaml?.partner_buttonText}
                shape="circle"
                qrcode={webhotYaml?.partner_qrcode}
              />
            </div>
          </SectionSubstance>
        )}
        <SectionSubstance
          className={styles.webhotCargo}
          titleMb={webhotYaml?.cargo_titleMb}
          title={webhotYaml?.cargo_title}
          titleTextAlign="left"
        >
          <CargoCard
            className={styles.cargoCard}
            dataSource={webhotYaml?.cargo_dataList?.map((item) => ({
              ...item,
              imgUrl: item?.imgUrl,
              imgUrlMb: item?.imgUrlMb,
            }))}
          />
        </SectionSubstance>
        <SectionSubstance
          className={styles.webhotProduct}
          title={webhotYaml?.product_title}
          titleMb={webhotYaml?.product_titleMb}
          titleTextAlign="left"
        >
          <ProductCard
            className="product-card"
            dataSource={webhotYaml?.product_dataList?.map((item) => ({
              ...item,
              imgUrl: item?.imgUrl,
              imgUrlMb: item?.imgUrl,
            }))}
          />
        </SectionSubstance>
        <ArticleFooter
          className={styles.webhotFooter}
          title={webhotYaml?.digitization_title}
          gameDsc={webhotYaml?.digitization_desc}
          btnText={webhotYaml?.digitization_btnText}
          btnHref={webhotYaml?.digitization_btnHref}
          orderText={webhotYaml?.digitization_orderText}
          orderHref={webhotYaml?.digitization_orderHref}
        />
      </main>
    </>
  )
}

export default Webhot
